import { ValidationHelper } from '../../../../../helpers';
import { OverlayLayer } from './overlayLayer';
// Layer that has a predefined style in geoServer (not customizable)
export class OverlayBasicLayer extends OverlayLayer {
    constructor(id, name, url, type, isVisible, legend, layers, center, selectable, version, opacity, format, subtitle, nameLegend, hidden, bbox) {
        super(id, name, url, type, isVisible, opacity, selectable, version, center, format, subtitle, nameLegend, hidden, bbox);
        this.legend = legend;
        this.layers = layers;
        this.validate();
    }
    /**
     * Check if all mandatory properties exist
     * @returns A boolean value.
     */
    existProperties() {
        const existProperties = super.existProperties();
        return (existProperties
            && ValidationHelper.existProperty(this.layers)
            && ValidationHelper.existProperty(this.legend));
    }
    /**
     * Checks property types.
     *
     * @returns The return value is a boolean.
     */
    sameTypeProperties() {
        const sameTypeProperties = super.sameTypeProperties();
        return (sameTypeProperties
            && ValidationHelper.sameTypeProperty(this.layers, 'object')
            && ValidationHelper.sameTypeProperty(this.legend, 'object'));
    }
}
//# sourceMappingURL=overlayBasicLayer.js.map